export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
            <path d="M25 46V53M38 46V53" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M54.3333 11.7039V11.704L54.3437 11.7038C54.5875 11.7002 54.8316 11.7506 55.0627 11.8545C55.2941 11.9585 55.5101 12.1152 55.6958 12.3199C55.8817 12.5248 56.033 12.773 56.1374 13.0519C56.2419 13.3309 56.2964 13.6325 56.2964 13.9387V43.7347C56.2964 44.2399 56.1159 44.7109 55.8148 45.0471C55.516 45.3807 55.1284 45.5509 54.7431 45.5509H9.60765C9.12717 45.5459 8.64982 45.3295 8.28562 44.9186C7.91851 44.5043 7.70216 43.9298 7.70363 43.3177V43.3161V13.9388V13.9387C7.70359 13.3278 7.91974 12.7546 8.28578 12.3405C8.64848 11.9301 9.12364 11.7123 9.60288 11.7039H54.3333Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
            />
            <path d="M19 53.0001H45.3125" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M11 14.6731H53.3264C53.4901 14.6731 53.6228 14.8058 53.6228 14.9695V42.2847C53.6228 42.4484 53.4901 42.5811 53.3264 42.5811H11C10.8363 42.5811 10.7036 42.4484 10.7036 42.2847V14.9695C10.7036 14.8058 10.8363 14.6731 11 14.6731Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinejoin="round"
            />
        </svg>
    );
}
